/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * \"The payment method term and condition. <br>This term allows you to specify the address books fromwhich the customer can select the shipping and billing addresses for an order. When completing the checkout process for an order, the customer can select an address from the following address books: their personal address book, their parent organization\'s address book, or their business account organization\'s address book.\"
 * @export
 * @interface AddressBookTCAllOf
 */
export interface AddressBookTCAllOf {
    /**
     * The full entity class name of the term and condition.
     * @type {string}
     * @memberof AddressBookTCAllOf
     */
    _class?: AddressBookTCAllOfClassEnum;
    /**
     * The usage of the address.
     * @type {string}
     * @memberof AddressBookTCAllOf
     */
    usage?: AddressBookTCAllOfUsageEnum;
    /**
     * If the billing address is not predefined, customers can whether or not select and address from their personal address book.
     * @type {boolean}
     * @memberof AddressBookTCAllOf
     */
    usePersonal?: boolean;
    /**
     * If the billing address is not predefined, customers can whether or not select and address from their parent organization\'s address book.
     * @type {boolean}
     * @memberof AddressBookTCAllOf
     */
    useParentOrganization?: boolean;
    /**
     * If the billing address is not predefined, customers can whether or not select and address from their business account organization\'s address book.
     * @type {boolean}
     * @memberof AddressBookTCAllOf
     */
    useAccountHolderOrganization?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum AddressBookTCAllOfClassEnum {
    ComIbmCommerceTradingEntitiesAddressBookTc = 'com.ibm.commerce.trading.entities.AddressBookTC'
}
/**
    * @export
    * @enum {string}
    */
export enum AddressBookTCAllOfUsageEnum {
    Shipping = 'shipping',
    Billing = 'billing'
}



